import { gql } from '@apollo/client';

export const VENDORS_LIST = gql`
  query VendorsList {
    vendorsList {
      items {
        id
        name
        serviceType
        contactPerson
        phone
        email
      }
    }
  }
`;

export const VENDOR_CREATE = gql`
  mutation VendorCreate($data: VendorCreateInput!) {
    vendorCreate(data: $data) {
      id
    }
  }
`;

export const VENDOR_UPDATE = gql`
  mutation VendorUpdate($id: ID!, $data: VendorUpdateInput!) {
    vendorUpdate(id: $id, data: $data) {
      id
    }
  }
`;

export const VENDOR_DELETE = gql`
  mutation VendorDelete($id: ID!) {
    vendorDelete(id: $id) {
      success
    }
  }
`; 